import React from "react";

export interface Props {
  className?: string;
  onClick?: () => void;
}

export const Asset = (src: string) => (props: Props) => {
  return (
    <img
      style={{ cursor: props.onClick ? "pointer" : "initial" }}
      {...{ src, ...props }}
    />
  );
};
